'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { cx } from 'utils/cx'

import { dataTestIds } from '../../constants/dataTestIds/dataTestIds'
import { useAnalytics } from '../../contexts/AnalyticsProvider/AnalyticsProvider'
import { useColors } from '../../contexts/ColorsProvider/ColorsProvider'
import { useSizeGuide } from '../../contexts/SizeGuideProvider/SizeGuideProvider'
import { useSizes } from '../../contexts/SizesProvider/SizesProvider'
import { getShowSizeGuideByDisclaimer } from '../../utils/getShowSizeGuideByDisclaimer/getShowSizeGuideByDisclaimer'

import styles from './SizeGuide.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface SizeGuideProps {
	isSheet?: boolean
	className?: string
}

export function SizeGuide({
	className,
	isSheet = false,
}: SizeGuideProps): React.ReactNode {
	const { sendClickSizeGuide } = useAnalytics()
	const { setIsSizeGuideOpen } = useSizeGuide()
	const { openSheet } = useSizes()
	const { selectedColor } = useColors()

	const shouldShowSizeGuide = getShowSizeGuideByDisclaimer(
		selectedColor.disclaimer
	)

	const { t } = useLabels()

	const onSizeGuideClick = (): void => {
		setIsSizeGuideOpen(true)
		sendClickSizeGuide()

		if (isSheet) {
			openSheet(false)
		}
	}

	return shouldShowSizeGuide ? (
		<button
			className={cx(styles.sizeGuide, text.bodyMRegularUnderline, className)}
			onClick={onSizeGuideClick}
			data-testid={dataTestIds['pdp.sizeGuide']}
		>
			{t('sizeGuide.link')}
		</button>
	) : null
}
